module.exports = __webpack_public_path__ + "img/welcome2.e914c3c3.png";